module.exports = __webpack_public_path__ + "img/eRBanner.0543bce6.png";